/**
 * Копирование текста в буфер обмена. Чистая функция, отделённая от
 * React-обработчика: `navigator.clipboard` доступен не во всяком контексте,
 * и оба случая недоступности — отсутствие самого `clipboard` и отказ
 * `writeText` — сводятся к одному названному исходу.
 */
export type CopyOutcome = "copied" | "failed";

export async function copyText(
  text: string,
  clipboard: Pick<Clipboard, "writeText"> | undefined,
): Promise<CopyOutcome> {
  if (clipboard === undefined) {
    return "failed";
  }
  try {
    await clipboard.writeText(text);
    return "copied";
  } catch {
    return "failed";
  }
}
